import angular, { IQService } from 'angular';
import { CartService } from '../../tn.cart/service.tn.cart';
import { FontFamilyService, hasOwnProperty } from '../../tn.common';
import { PopoverService } from '../../tn.popover/service.tn.popover';
import { BucketService } from '../../tn.pricing/buckets.service/buckets';
import { Pricing } from '../../tn.pricing/service.tn.pricing';
import { daysBetween } from '../days-between.filter/days-between';
import { EMPTY_FONT_RIGHTS } from '../font-rights';
import { LicenseService } from '../license.service/license-service';
import UpgradeRenewConfirmationTemplate from './confirmation.html';
import UpgradeRenewMultipleLicenseTemplate from './upgrade-renew-multiple-licenses.html';
import UpgradeRenewSingleLicenseTemplate from './upgrade-renew-single-license.html';

export function populateUpgradeRenewLicenseTemplateCache($templateCache) {
    $templateCache.put(
        'upgrade-renew-licenses.view/upgrade-renew-single-license.html',
        UpgradeRenewSingleLicenseTemplate
    );
    $templateCache.put(
        'upgrade-renew-licenses.view/upgrade-renew-multiple-licenses.html',
        UpgradeRenewMultipleLicenseTemplate
    );
    $templateCache.put(
        'upgrade-renew-licenses.view/confirmation.html',
        UpgradeRenewConfirmationTemplate
    );
}
populateUpgradeRenewLicenseTemplateCache.$inject = ['$templateCache'];

UpgradeRenewLicensesController.$inject = [
    '$scope',
    '$filter',
    'tnLicenseService',
    'tn.cart.service',
    'tnBuckets',
    'tn.pricing.service',
    'tnLicenseListService',
    '$q',
    '$tnPopover',
    'FontFamilyService',
];
export function UpgradeRenewLicensesController( // eslint-disable-line max-statements
    $scope,
    $filter,
    licenseService: LicenseService,
    cartService: CartService,
    bucketsService: BucketService,
    pricingService: Pricing,
    licenseListService,
    $q: IQService,
    $tnPopover: PopoverService,
    familyService: FontFamilyService
) {
    const rightQtyKeys = {
        app: 'apps',
        desktop: 'computers',
        epub: 'ebooks',
        web: 'views',
    };
    let selectedLicenseWatcher;
    let fontRightWatcher;
    const vm = angular.extend(this, {
        states: {
            'renew-single-license': {
                templateUrl:
                    'upgrade-renew-licenses.view/upgrade-renew-single-license.html',
            },
            'renew-multiple-licenses': {
                templateUrl:
                    'upgrade-renew-licenses.view/upgrade-renew-multiple-licenses.html',
            },
            confirmation: {
                templateUrl: 'upgrade-renew-licenses.view/confirmation.html',
            },
        },
        currentState: 'renew-single-license',
        licenseTypes: [],
        licenseTypesDict: {},
        getLicenseTypeName: getLicenseTypeName,
        getQty: getQty,
        getYears: getYears,
        areFontRightsChanged: areFontRightsChanged,
        disableUpgradeRenewButton: disableUpgradeRenewButton,
        isTermChangeEnabled: false,
        originalValues: {},
        selectedLicensesValues: {
            qty: null,
            years: null,
        },
        families: {},
        fontRights: angular.copy(EMPTY_FONT_RIGHTS),
        licenses: [],
        currentValuesYears: null,
        currentValuesQty: null,
        selectedLicenses: [],
        licensesUpgradeDict: {},
        initialize: initialize,
        addToCart: addToCart,
        goToState: goToState,
        calculatedPrices: {
            web: {},
            web_self_hosted: {},
            app: {},
            cpu: {},
            ebook: {},
        },
        countLicenseTypes: {},
        firstBucket: {},

        cart: null,

        calculateAppPrice,
        calculateWebPrice,
        expiresSoon,

        multipleFontTypes: false,
        webState: 'hosted',
        webStateMixed: false,

        selectLabels: {},
        subTotal: 0,
        expirationDate: {},
        toggleSelect,
        setWebState,
    });

    //Called when popover opens, sets up license template and looks up family buckets
    function initialize(
        cart,
        licenses,
        licenseTypes,
        popoverSection = 'yourFonts'
    ) {
        vm.popoverSection = popoverSection;
        vm.cart = cart || cartService.getCart();
        vm.licenseTypes = licenseTypes;
        angular.copy(
            licenseTypes.reduce((obj, type) => {
                obj[type] = true;
                return obj;
            }, {}),
            vm.licenseTypesDict
        );
        // TODO: change this if we allow tweaking multiple license types at the same time.
        vm.selectedLicenses = licenses.filter((li) =>
            hasOwnProperty(li.fontRights, vm.licenseTypes[0])
        );
        vm.countLicenseTypes = {};
        vm.originalValues = {
            qty: null,
            years: null,
        };

        _getLicensesValues();
        _checkWebState();

        angular.copy({}, vm.licensesUpgradeDict);
        vm.selectedLicenses.forEach((license) => {
            vm.licensesUpgradeDict[_getLicenseFont(license).id] = {
                fontRights: license.fontRights,
            };
        });

        angular.copy(EMPTY_FONT_RIGHTS, vm.fontRights);
        if (vm.selectedLicenses.length === 1) {
            goToState('renew-single-license');
            _checkSingleFontTypes();
        } else {
            goToState('renew-multiple-licenses');
            _checkMultipleFontTypes();
        }
        _updateFamilies();
        // we need to wait on buckets to setDefaults
        _updateBuckets().then(() => setDefaults(vm.licenseTypes));
        _updateCurrentValues(vm.selectedLicenses);

        if (selectedLicenseWatcher) {
            selectedLicenseWatcher();
        }
        if (fontRightWatcher) {
            fontRightWatcher();
        }

        // Update the subtotal as the fontRights change
        selectedLicenseWatcher = $scope.$watch(
            'popover.selectedLicenses',
            () => {
                _updateBuckets();
            },
            true
        );
        // Update the subtotal as the fontRights change
        fontRightWatcher = $scope.$watch(
            'popover.fontRights',
            () => {
                _onRightsChanged();
            },
            true
        );
    }

    function _onRightsChanged() {
        const currentQty = _getMaxQty();
        const yearsChanged = Object.keys(vm.licenseTypesDict).every(
            (type) => vm.fontRights[type].years !== 0
        );
        if (
            (!yearsChanged && currentQty <= vm.currentValuesQty) ||
            (vm.currentValuesQty === 'unlimited' &&
                currentQty !== 'unlimited' &&
                !yearsChanged) ||
            (vm.currentValuesYears === 'unlimited' &&
                yearsChanged &&
                currentQty === vm.currentValuesQty)
        ) {
            setDefaults(vm.licenseTypes);
        }
        _updateCurrentValues(vm.selectedLicenses);
        vm.isTermChangeEnabled =
            vm.originalValues.years !== 'unlimited' ||
            currentQty !== vm.originalValues.qty;

        _getLicensesValues(false);
        calculateExpirationDate();
        pricingService
            .calculateSubTotal(_buildLicense(), vm.licensesUpgradeDict)
            .then((subTotal) => (vm.subTotal = subTotal));
    }

    function _checkMultipleFontTypes() {
        if (vm.licenseTypes.length > 1) {
            vm.multipleFontTypes = true;
        }

        vm.selectedLicenses.forEach((license) => {
            Object.keys(vm.fontRights).forEach((fontType) => {
                // eslint-disable-line complexity
                if (fontType in license.fontRights) {
                    if (
                        license.fontRights[fontType].years &&
                        vm.selectedLicensesValues.years !== -1 &&
                        (vm.selectedLicensesValues.years === null ||
                            !vm.selectedLicensesValues.years ||
                            license.fontRights[fontType].years === -1 ||
                            vm.selectedLicensesValues.years <
                                license.fontRights[fontType].years)
                    ) {
                        vm.selectedLicensesValues.years =
                            license.fontRights[fontType].years;
                    }
                    if (
                        license.fontRights[fontType].qty &&
                        vm.selectedLicensesValues.qty !== -1 &&
                        (vm.selectedLicensesValues.qty === null ||
                            !vm.selectedLicensesValues.qty ||
                            license.fontRights[fontType].qty === -1 ||
                            vm.selectedLicensesValues.qty <
                                license.fontRights[fontType].qty)
                    ) {
                        vm.selectedLicensesValues.qty =
                            license.fontRights[fontType].qty;
                    }
                    if (fontType in vm.countLicenseTypes) {
                        vm.countLicenseTypes[fontType]++;
                    } else {
                        vm.countLicenseTypes[fontType] = 1;
                    }
                }
            });
        });
    }

    function expiresSoon() {
        const fontTypes = Object.keys(vm.fontRights);
        return vm.selectedLicenses.some((license) =>
            fontTypes.some(
                (fontType) =>
                    license.fontRights[fontType] &&
                    license.fontRights[fontType].end &&
                    daysBetween(license.fontRights[fontType].end) <= 30
            )
        );
    }

    function _checkSingleFontTypes() {
        const license = vm.selectedLicenses[0];
        Object.keys(vm.fontRights).forEach((fontType) => {
            if (
                fontType in license.fontRights &&
                vm.licenseTypes.includes(fontType)
            ) {
                if (license.fontRights[fontType].renew) {
                    vm.selectedLicensesValues.years =
                        license.fontRights[fontType].years;
                } else {
                    vm.selectedLicensesValues.years = expiresSoon() ? 1 : 0;
                }
                if (license.fontRights[fontType].upgrade) {
                    vm.selectedLicensesValues.qty =
                        license.fontRights[fontType][rightQtyKeys[fontType]];
                } else {
                    vm.selectedLicensesValues.qty = 0;
                }
            }
        });
    }

    function calculateExpirationDate() {
        vm.expirationDate = {
            web: new Date(),
            app: new Date(),
            cpu: new Date(),
            ebook: new Date(),
        };

        vm.selectedLicenses.forEach((license) => {
            Object.keys(license.fontRights).forEach((fontType) => {
                let expirationDate = license.fontRights[fontType].end;

                const today = new Date();
                const currentYears = getYears(fontType);

                if (currentYears !== 'unlimited') {
                    if (expirationDate) {
                        expirationDate = new Date(
                            expirationDate.replace(
                                /(\d{4})-(\d{2})-(\d{2})/,
                                '$2/$3/$1'
                            )
                        );
                    }
                    // treat renewing, free trials or downgrading perpetual as starting from the current day
                    if (
                        today > expirationDate ||
                        license.fontRights[fontType].years === -2 ||
                        vm.currentValuesYears === 'unlimited'
                    ) {
                        expirationDate = today;
                    }
                    expirationDate.setYear(
                        expirationDate.getFullYear() +
                            vm.fontRights[fontType].years
                    );
                }

                if (vm.expirationDate[fontType] < expirationDate) {
                    vm.expirationDate[fontType] = expirationDate;
                } else if (currentYears === 'unlimited') {
                    vm.expirationDate[fontType] = 'unlimited';
                }
            });
        });
    }

    function _setLicensesValues(fontType, license) {
        if (vm.fontRights[fontType].views < license.fontRights[fontType].qty) {
            vm.fontRights[fontType].views = license.fontRights[fontType].qty;
        }
        if (vm.fontRights[fontType].apps < license.fontRights[fontType].qty) {
            vm.fontRights[fontType].apps = license.fontRights[fontType].qty;
        }
        if (
            vm.fontRights[fontType].years < license.fontRights[fontType].years
        ) {
            vm.fontRights[fontType].years = license.fontRights[fontType].years;
        }
        if (!vm.originalValues.qty || !vm.originalValues.years) {
            vm.originalValues.qty = license.fontRights[fontType].qty;
            vm.originalValues.years =
                license.fontRights[fontType].original_years;
        }
    }

    function _getLicensesValues(changeValues = true) {
        vm.selectedLicenses.forEach((license) => {
            Object.keys(license.fontRights).forEach((fontType) => {
                if (
                    changeValues &&
                    Object.keys(license.fontRights[fontType]).some(
                        (attr) => attr in ['original_years']
                    )
                ) {
                    _setLicensesValues(fontType, license);
                } else if (changeValues && license.fontRights[fontType].id) {
                    const licenseId = license.fontRights[fontType].id;
                    licenseService
                        .getLicensesFromServer()
                        .then((serverLicenses) => {
                            const fontRights = serverLicenses.map(
                                (element) => element.fontRights
                            );
                            const serverLicense = fontRights.find(
                                (element) =>
                                    element[fontType] &&
                                    element[fontType].id === licenseId
                            );
                            license.fontRights[fontType].original_years = //eslint-disable-line camelcase
                                serverLicense[fontType].years;
                            license.fontRights[fontType].start =
                                serverLicense[fontType].start;
                            license.fontRights[fontType].end =
                                serverLicense[fontType].end;
                            license.fontRights[fontType].qty =
                                serverLicense[fontType].qty;
                            license.fontRights[fontType].price_paid = //eslint-disable-line camelcase
                                serverLicense[fontType].price_paid; //eslint-disable-line camelcase
                            _setLicensesValues(fontType, license);
                        });
                }
            });
        });
    }

    function _checkWebState() {
        const hosted = vm.selectedLicenses.reduce((count, license) => {
            if (
                hasOwnProperty(license.fontRights, 'web') &&
                !license.fontRights.web.self_hosted
            ) {
                count++;
                return count;
            }
            return count;
        }, 0);
        const selfHosted = vm.selectedLicenses.length - hosted;

        vm.webState = selfHosted > hosted ? 'self-hosted' : 'hosted';
        vm.webStateMixed = selfHosted !== 0 && hosted !== 0;
        // Update pricing
        pricingService
            .calculateSubTotal(_buildLicense(), vm.licensesUpgradeDict)
            .then((subTotal) => (vm.subTotal = subTotal));
    }

    // TODO:  Clean this up.  I don't like having to munge it into an array before sending it to the add to cart
    // section...But using a filter on the template means it gets checked ~175 times on initial page load.
    function _getLicenseTypeArray() {
        return Object.keys(vm.licenseTypesDict).filter(
            (key) => vm.licenseTypesDict[key] === true
        );
    }

    function getLicenseTypeName(licenseType) {
        let name = '';
        switch (licenseType) {
            case 'web':
                name = 'web';
                break;
            case 'app':
                name = 'application';
                break;
            case 'ebook':
                name = 'ePub';
                break;
            case 'cpu':
                name = 'desktop';
                break;
        }

        return name;
    }

    function getYears(key) {
        // If "Do Not Change" is selected return the current license's years
        if (vm.fontRights[key].years === 0) {
            return vm.currentValuesYears;
        }
        return vm.fontRights[key].years > 0
            ? vm.fontRights[key].years
            : 'unlimited';
    }

    function getQty(key) {
        const qtyType = rightQtyKeys[key];
        // If "Do Not Change" is selected return the current license's quantity
        if (vm.fontRights[key][qtyType] === 0) {
            return vm.currentValuesQty;
        }
        return vm.fontRights[key][qtyType] > 0
            ? vm.fontRights[key][qtyType]
            : 'unlimited';
    }

    function areExpiringFontsRighChanged(rightType, rightQty) {
        const currentDate = new Date();
        return (
            (vm.fontRights[rightType].years !== 0 &&
                vm.fontRights[rightType].years !== null) ||
            ((vm.expirationDate[rightType] > currentDate ||
                vm.expirationDate[rightType] === 'unlimited') &&
                (vm.fontRights[rightType][rightQty] !== 0 ||
                    vm.selectedLicensesValues.qty <=
                        vm.fontRights[rightType][rightQty]))
        );
    }

    function areNonExpiringFontsRightChanged(rightType, rightQty) {
        return (
            vm.fontRights[rightType][rightQty] !== 0 &&
            vm.fontRights[rightType][rightQty] !== null &&
            vm.fontRights[rightType][rightQty] !== vm.currentValuesQty
        );
    }

    function areFontRightsChanged(licenseType) {
        if (typeof licenseType === 'undefined') {
            licenseType = vm.licenseTypes[0];
        }
        if (licenseType === 'app') {
            return areExpiringFontsRighChanged('app', 'apps');
        } else if (licenseType === 'desktop') {
            return areNonExpiringFontsRightChanged('desktop', 'computers');
        } else if (licenseType === 'epub') {
            return areNonExpiringFontsRightChanged('epub', 'ebooks');
        } else if (licenseType === 'web') {
            return areExpiringFontsRighChanged('web', 'views');
        }
    }

    function disableUpgradeRenewButton() {
        const currentDate = new Date();
        const licenseType = vm.licenseTypes[0];
        return (
            (!(vm.licenseTypesDict.desktop || vm.licenseTypesDict.epub) &&
                vm.selectedLicenses.length === 1 &&
                !vm.licenses[0].fontRights[licenseType].renew &&
                vm.fontRights[licenseType].end &&
                currentDate > new Date(vm.fontRights[licenseType].end)) ||
            (vm.licenseTypes.length === 1 &&
                vm.fontRights[licenseType].years === 0 &&
                vm.getQty(vm.licenseTypes[0]) === vm.currentValuesQty) ||
            (vm.licenseTypesDict.desktop &&
                (!vm.fontRights.desktop.computers ||
                    vm.fontRights.desktop.computers <= vm.currentValuesQty)) ||
            (vm.licenseTypesDict.epub &&
                (!vm.fontRights.epub.ebooks ||
                    vm.fontRights.epub.ebooks <= vm.currentValuesQty))
        );
    }

    function _getMaxQty() {
        return Object.keys(vm.licenseTypesDict).reduce((max, type) => {
            const qty = getQty(type);
            return qty === 'unlimited' || qty > max ? qty : max;
        }, null);
    }

    function _updateFamilies() {
        const familyIdsToFetch = [];

        //Only fetch families that we don't have yet
        vm.selectedLicenses.forEach((license) => {
            const font = _getLicenseFont(license);
            if (
                !hasOwnProperty(vm.families, font.family) &&
                familyIdsToFetch.indexOf(font.family) === -1
            ) {
                familyIdsToFetch.push(font.family);
            }
        });

        return familyService
            .list({ id: familyIdsToFetch })
            .then(({ results: families }) =>
                families.forEach((family) => {
                    vm.families[family.id] = family;
                })
            );
    }

    function _updateBuckets() {
        const styles = vm.selectedLicenses.map((l) => _getLicenseFont(l));
        const promise = bucketsService.getIntersectingBuckets(styles);

        return promise.then((intersectingBuckets) => {
            const promises = [];
            // set first bucket to use in templates
            const firstBucket = intersectingBuckets;
            const calculatedPrices = vm.calculatedPrices;
            if (firstBucket && Object.keys(firstBucket).length !== 0) {
                let doneWithEbook = false;
                let doneWithCPU = false;
                // get all the different kinds of licenses in there ...
                Object.keys(calculatedPrices).forEach((key) =>
                    firstBucket[key].forEach((bucket) => {
                        //eslint-disable-line complexity
                        // no matter what, we're gonna have nested if statements,
                        // if(key == epub) { if(vm.isEpubLicense) { } } else if /*...*/
                        // this necessarily makes complexity > 10
                        switch (key) {
                            case 'web_self_hosted':
                            case 'web':
                                firstBucket['year'].forEach((term) =>
                                    promises.push(
                                        calculateWebPrice(
                                            bucket.key,
                                            term.key
                                        ).then((total) => {
                                            if (
                                                calculatedPrices[key][
                                                    term.key
                                                ] === undefined
                                            ) {
                                                calculatedPrices[key][
                                                    term.key
                                                ] = {};
                                            }
                                            calculatedPrices[key][term.key][
                                                bucket.key
                                            ] = total;
                                        })
                                    )
                                );
                                break;
                            case 'app':
                                firstBucket['year'].forEach((term) =>
                                    promises.push(
                                        calculateAppPrice(
                                            bucket.key,
                                            term.key
                                        ).then((total) => {
                                            if (
                                                calculatedPrices[key][
                                                    term.key
                                                ] === undefined
                                            ) {
                                                calculatedPrices[key][
                                                    term.key
                                                ] = {};
                                            }
                                            calculatedPrices[key][term.key][
                                                bucket.key
                                            ] = total;
                                        })
                                    )
                                );
                                break;
                            case 'ebook':
                                if (!doneWithEbook) {
                                    firstBucket['ebook'].forEach((ebook) =>
                                        promises.push(
                                            calculateEpubPrice(ebook.key).then(
                                                (total) => {
                                                    if (
                                                        calculatedPrices[key][
                                                            ebook.key
                                                        ] === undefined
                                                    ) {
                                                        calculatedPrices[key][
                                                            ebook.key
                                                        ] = {};
                                                    }
                                                    calculatedPrices[key][
                                                        ebook.key
                                                    ] = total;
                                                }
                                            )
                                        )
                                    );
                                    doneWithEbook = true;
                                }
                                break;
                            case 'cpu':
                                if (!doneWithCPU) {
                                    firstBucket['cpu'].forEach((cpu) =>
                                        promises.push(
                                            calculateCpuPrice(cpu.key).then(
                                                (total) => {
                                                    if (
                                                        calculatedPrices[key][
                                                            cpu.key
                                                        ] === undefined
                                                    ) {
                                                        calculatedPrices[key][
                                                            cpu.key
                                                        ] = {};
                                                    }
                                                    calculatedPrices[key][
                                                        cpu.key
                                                    ] = total;
                                                }
                                            )
                                        )
                                    );
                                    doneWithCPU = true;
                                }
                                break;
                        }
                    })
                );
            }
            vm.firstBucket = firstBucket;
            return $q.all(promises).then(() => {
                // relcalculate the subtotal
                _onRightsChanged();
            });
        });
    }

    function _updateCurrentValues(licenses) {
        if (
            vm.licenseTypesDict.web ||
            vm.licenseTypesDict.app ||
            vm.licenseTypesDict.epub ||
            vm.licenseTypesDict.desktop
        ) {
            if (vm.selectedLicenses.length === 1) {
                vm.currentValuesQty =
                    licenses[0].fontRights[vm.licenseTypes[0]].qty > -1
                        ? licenses[0].fontRights[vm.licenseTypes].qty
                        : 'unlimited';
                if (licenses[0].fontRights[vm.licenseTypes[0]].years !== -1) {
                    vm.currentValuesYears =
                        licenses[0].fontRights[vm.licenseTypes[0]].years;
                } else {
                    vm.currentValuesYears = 'unlimited';
                }
            } else {
                vm.currentValuesQty =
                    vm.selectedLicensesValues.qty > -1
                        ? vm.selectedLicensesValues.qty
                        : 'unlimited';
                if (vm.selectedLicensesValues.years !== -1) {
                    vm.currentValuesYears = vm.selectedLicensesValues.years;
                } else {
                    vm.currentValuesYears = 'unlimited';
                }
            }
        }
        if (vm.originalValues.qty === -1) {
            vm.originalValues.qty = 'unlimited';
        }
        if (vm.originalValues.years === -1) {
            vm.originalValues.years = 'unlimited';
        }
    }

    function changeNumbersLabel(label) {
        if (label.indexOf('-') !== -1 && label.indexOf(',') === -1) {
            const split = label.split('-');
            const newLabel1 = $filter('number')(split[0]),
                newLabel2 = $filter('number')(split[1]);
            return newLabel1 + '-' + newLabel2;
        }

        return label.charAt(0).toUpperCase() + label.slice(1);
    }

    function goToState(state) {
        if (Object.keys(vm.states).indexOf(state) > -1) {
            vm.currentState = state;
        } else {
            // console.log('state', state, 'does not exist');
        }
    }

    function addToCart() {
        const popover = vm;
        if (
            !(
                popover.licenseTypesDict.desktop ||
                popover.licenseTypesDict.web ||
                popover.licenseTypesDict.app ||
                popover.licenseTypesDict.epub
            )
        ) {
            return;
        }

        licenseListService.addLicenses(
            vm.cart.license,
            _buildLicense(),
            _getLicenseTypeArray(),
            false
        );

        if (vm.cart.id !== undefined && vm.cart.id !== null) {
            cartService.updateCartOnServer(vm.cart);
        }

        if (vm.popoverSection === 'yourFonts') {
            goToState('confirmation');
        } else {
            $tnPopover.hide();
        }
    }

    function calculateAppPrice(apps, years) {
        return pricingService
            .calculateLicensePrices(
                vm.selectedLicenses.map((license) => ({
                    fontRights: { app: { apps: apps, years: years } },
                    font: _getLicenseFont(license),
                }))
            )
            .then((result) => result.reduce((total, p) => total + p.base, 0));
    }

    function calculateWebPrice(views, years) {
        const selfHosted = vm.webState === 'self-hosted';

        return pricingService
            .calculateLicensePrices(
                vm.selectedLicenses.map((license) => ({
                    fontRights: {
                        web: {
                            views: views,
                            years: years,
                            self_hosted: selfHosted,
                        },
                    }, //eslint-disable-line camelcase
                    font: _getLicenseFont(license),
                }))
            )
            .then((result) => result.reduce((total, p) => total + p.base, 0));
    }

    function calculateCpuPrice(computers) {
        return pricingService
            .calculateLicensePrices(
                vm.selectedLicenses.map((license) => ({
                    fontRights: { desktop: { computers: computers } },
                    font: _getLicenseFont(license),
                }))
            )
            .then((result) => result.reduce((total, p) => total + p.base, 0));
    }

    function calculateEpubPrice(ebooks) {
        return pricingService
            .calculateLicensePrices(
                vm.selectedLicenses.map((license) => ({
                    fontRights: { epub: { ebooks: ebooks } },
                    font: _getLicenseFont(license),
                }))
            )
            .then((result) => result.reduce((total, p) => total + p.base, 0));
    }

    function setWebState(state) {
        vm.webState = state;
        toggleSelect('web', true);
    }

    function toggleSelect(selectName, isActive) {
        // Set defaults or null on deselect
        vm.fontRights[selectName] = angular.copy(EMPTY_FONT_RIGHTS[selectName]);

        if (isActive) {
            vm.licenseTypesDict[selectName] = true;

            //Note: this code assumes that every family has the same number of buckets
            // and that they only differ on the price
            const bucketTemplate = vm.firstBucket;

            switch (selectName) {
                case 'app':
                    vm.fontRights.app.apps = 0;
                    vm.fontRights.app.years = 0;
                    vm.selectLabels.appApps = 'Do not change';
                    vm.selectLabels.appYears = 'Do not change';
                    break;
                case 'cpu':
                    vm.selectLabels.desktopCPUs = bucketTemplate.cpu[0].key;
                    break;
                case 'epub':
                    vm.selectLabels.epubEbooks = bucketTemplate.ebook[0].key;
                    break;
                case 'web':
                    _setWebDefaults();
            }
        } else {
            vm.licenseTypesDict[selectName] = false;
        }
    }

    function setDefaults(licenseTypes) {
        if (licenseTypes.length === 1 && licenseTypes[0] === 'web') {
            _setWebDefaults();
        } else if (licenseTypes.length === 1 && licenseTypes[0] === 'desktop') {
            vm.selectLabels.desktopCPUs = 'Do not change';
        } else if (licenseTypes.length === 1 && licenseTypes[0] === 'epub') {
            vm.selectLabels.epubEbooks = 'Do not change';
        } else {
            licenseTypes.forEach((type) => toggleSelect(type, true));
        }
        _assignSelectValues();
    }

    function _setWebDefaults() {
        const bucketTemplate = vm.firstBucket;
        if (!Array.isArray(bucketTemplate.year)) {
            return;
        }
        if (
            vm.originalValues.years &&
            (vm.originalValues.years >= 1 ||
                vm.originalValues.years === 'unlimited')
        ) {
            vm.fontRights.web.years = 0;
            vm.selectLabels.webYears = 'Do not change';
        } else {
            vm.fontRights.web.years = bucketTemplate.year[0].key;
            vm.selectLabels.webYears =
                bucketTemplate.year[0].key +
                (bucketTemplate.year[0].key === 1 ? ' year' : ' years');
        }
        let webBucketKey = bucketTemplate.web[0].key;
        if (vm.webState === 'self-hosted') {
            webBucketKey = bucketTemplate.web_self_hosted[0].key;
            vm.fontRights.web.self_hosted = true; //eslint-disable-line camelcase
        }
        if (
            vm.originalValues.qty &&
            (vm.originalValues.qty === 'unlimited' ||
                vm.originalValues.qty >= webBucketKey)
        ) {
            vm.selectLabels.webViews = 'Do not change';
            vm.fontRights.web.views = 0;
        } else {
            vm.selectLabels.webViews = changeNumbersLabel('0-' + webBucketKey);
            vm.fontRights.web.views = webBucketKey;
        }
    }

    function _buildLicense() {
        vm.licenses = [];

        vm.selectedLicenses.forEach((license) => {
            const fontRights = angular.copy(vm.fontRights);
            Object.keys(license.fontRights).forEach((fontType) => {
                fontRights[fontType].id = license.fontRights[fontType].id;
                if (fontType === 'web') {
                    fontRights[fontType].self_hosted = //eslint-disable-line camelcase
                        vm.webState === 'self-hosted';
                }
                // TODO: Once we allow all license types make the code more agnostic
                if (
                    (fontType === 'web' || fontType === 'app') &&
                    hasOwnProperty(vm.licenseTypesDict, fontType) &&
                    vm.licenseTypesDict[fontType]
                ) {
                    if (getQty(fontType) !== vm.currentValuesQty) {
                        fontRights[fontType].upgrade = true;
                    } else {
                        const qtyType = rightQtyKeys[fontType];
                        vm.fontRights[fontType][qtyType] = vm.currentValuesQty;
                        delete fontRights[fontType]['upgrade'];
                    }
                    if (fontRights[fontType].years !== 0) {
                        fontRights[fontType].renew = true;
                    } else {
                        fontRights[fontType].years = vm.currentValuesYears;
                        delete fontRights[fontType]['renew'];
                    }
                } else if (fontType === 'epub' || fontType === 'desktop') {
                    fontRights[fontType].upgrade = true;
                    delete fontRights[fontType]['renew'];
                } else {
                    fontRights[fontType].renew = true;
                    delete fontRights[fontType]['upgrade'];
                }
                fontRights[fontType].start = license.fontRights[fontType].start;
                fontRights[fontType].end = license.fontRights[fontType].end;
                fontRights[fontType].qty = license.fontRights[fontType].qty;
                fontRights[fontType].price_paid = //eslint-disable-line camelcase
                    license.fontRights[fontType].price_paid; //eslint-disable-line camelcase
            });

            vm.licenses.push({
                font: _getLicenseFont(license),
                fontRights: fontRights,
            });
        });
        return vm.licenses;
    }

    function _getLicenseFont(license) {
        return license.style ? license.style : license.font;
    }

    function _selectedValuesExpiringLicenses(fontType) {
        const selectedQty = vm.selectedLicensesValues.qty;
        const selectedYears = vm.selectedLicensesValues.years;
        const bucketQty = vm.firstBucket[fontType].find(
            (detail) => detail.key === selectedQty
        );
        const bucketYears = vm.firstBucket.year.find(
            (detail) => detail.key === selectedYears
        );
        const qtyField = rightQtyKeys[fontType];
        vm.fontRights[fontType][qtyField] = selectedQty;
        vm.fontRights[fontType].years = selectedYears;
        if (fontType === 'web') {
            vm.selectLabels.webViews = bucketQty
                ? bucketQty.label
                : 'Do not change';
            vm.selectLabels.webYears = bucketYears
                ? bucketYears.label
                : 'Do not change';
        } else {
            vm.selectLabels.appApps = bucketQty
                ? bucketQty.label
                : 'Do not change';
            vm.selectLabels.appYears = bucketYears
                ? bucketYears.label
                : 'Do not change';
        }
    }

    function _selectedValuesNonExpiringLicenses(fontType, bucketKey) {
        const selectedQty = vm.selectedLicensesValues.qty;
        const bucketQty = vm.firstBucket[bucketKey].find(
            (detail) => detail.key === selectedQty
        );
        const qtyField = rightQtyKeys[fontType];
        vm.fontRights[fontType][qtyField] = selectedQty;
        if (fontType === 'desktop') {
            vm.selectLabels.desktopCPUs = bucketQty
                ? bucketQty.label
                : 'Do not change';
        } else {
            vm.selectLabels.epubEbooks = bucketQty
                ? bucketQty.label
                : 'Do not change';
        }
    }

    function _assignSelectValues() {
        const selectedQty = vm.selectedLicensesValues.qty;
        const selectedYears = vm.selectedLicensesValues.years;
        if (selectedQty || selectedYears) {
            if (vm.licenseTypes.includes('desktop')) {
                _selectedValuesNonExpiringLicenses('desktop', 'cpu');
            }
            if (vm.licenseTypes.includes('epub')) {
                _selectedValuesNonExpiringLicenses('epub', 'ebook');
            }
            if (vm.licenseTypes.includes('app')) {
                _selectedValuesExpiringLicenses('app');
            }
            if (vm.licenseTypes.includes('web')) {
                _selectedValuesExpiringLicenses('web');
            }
        }
    }
}
